export default __webpack_public_path__ + "static/media/1.83440df1.jpg";